import { Grid, Tooltip} from "@mui/material";

export function getStitchingtaskStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        assignedqty:{
            name:'assignedqty',
            label:'Assigned Qty',
            value:'',
            error:false,
            errorMessage:'You must enter Assigned Qty',
            required:true,
            fieldtype:'number'
        },
        receivedqty:{
            name:'receivedqty',
            label:'Received Qty',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        taskstatusid:{
            name:'taskstatusid',
            label:'Task Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        taskstatusname:{
            name:'taskstatusname',
            label:'Task Status Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderid:{
            name:'orderid',
            label:'orderId',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        productid:{
            name:'productid',
            label:'Product Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'bodynamiclist'
        },
        productname:{
            name:'productname',
            label:'Product Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        productorderid:{
            name:'productorderid',
            label:'Product Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        workerid:{
            name:'workerid',
            label:'Worker Id',
            value:'',
            error:false,
            errorMessage:'You must enter Worker Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        workername:{
            name:'workername',
            label:'Worker Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        earning:{
            name:'earning',
            label:'Earning',
            value:'',
            error:false,
            errorMessage:'You must enter Earning',
            required:true,
            fieldtype:'double'
        },
        workertypeid:{
            name:'workertypeid',
            label:'Worker Type Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        stitchingrate:{
            name:'stitchingrate',
            label:'Stitching Rate',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'title', width:150 },
        { field: 'assignedqty', headerName: 'Assigned Qty', width:150 },
        { field: 'receivedqty', headerName: 'Received Qty', width:150 },
        { field: 'taskstatusid', headerName: 'Task Status Id', width:150 },
        { field: 'taskstatusname', headerName: 'Task Status Name', width:150 },
        { field: 'orderid', headerName: 'orderId', width:150 },
        { field: 'productid', headerName: 'Product Id', width:150 },
        { field: 'productorderid', headerName: 'Product Order Id', width:150 },
        { field: 'workerid', headerName: 'Worker Id', width:150 },
        { field: 'workername', headerName: 'Worker Name', width:150 },
        { field: 'workertypeid', headerName: 'Worker Type Id', width:150 },
        { field: 'stitchingrate', headerName: 'Stitching Rate', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['assignedqty']:{
          ...formValues['assignedqty'],
          value:data.assignedqty,
        },['receivedqty']:{
          ...formValues['receivedqty'],
          value:data.receivedqty,
        },['taskstatusid']:{
          ...formValues['taskstatusid'],
          value:data.taskstatusid,
        },['taskstatusname']:{
          ...formValues['taskstatusname'],
          value:data.taskstatusname,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['productid']:{
          ...formValues['productid'],
          value:data.productid,
        },['productname']:{
          ...formValues['productname'],
          value:data.productname,
        },['productorderid']:{
          ...formValues['productorderid'],
          value:data.productorderid,
        },['workerid']:{
          ...formValues['workerid'],
          value:data.workerid,
        },['workername']:{
          ...formValues['workername'],
          value:data.workername,
        },['earning']:{
          ...formValues['earning'],
          value:data.earning,
        },['workertypeid']:{
          ...formValues['workertypeid'],
          value:data.workertypeid,
        },['stitchingrate']:{
          ...formValues['stitchingrate'],
          value:data.stitchingrate,
        },
      })
}